import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {RIBBON} from '../../../../../commons/constants/ribbons'
import {useSettings} from '../../../../../commons/hooks/use-settings'
import settingsParams from '../../../settingsParams'
import {useWidgetState} from '../../hooks/state-provider'
import {getRibbonData} from '../../selectors/events'
import {RibbonProps} from './interfaces'
import s from './ribbon.scss'

export const Ribbon = ({className, calendar, event}: RibbonProps) => {
  const {t} = useTranslation()
  const {get} = useSettings()

  const {visible, ribbon, textProp, defaultText} = useWidgetState(state => getRibbonData(state, event))

  if (!visible) {
    return null
  }

  const text = get(settingsParams[textProp]) || defaultText

  return (
    <div className={classNames(className)}>
      <div
        className={classNames(s.root, {
          [s.soldOut]: ribbon === RIBBON.SOLD_OUT && !calendar,
          [s.soldOutCalendar]: ribbon === RIBBON.SOLD_OUT && calendar,
          [s.rsvpClosed]: ribbon === RIBBON.RSVP_CLOSED && !calendar,
          [s.rsvpClosedCalendar]: ribbon === RIBBON.RSVP_CLOSED && calendar,
          [s.joinWaitlist]: ribbon === RIBBON.JOIN_WAITLIST && !calendar,
          [s.joinWaitlistCalendar]: ribbon === RIBBON.JOIN_WAITLIST && calendar,
          [s.offer]: ribbon === RIBBON.MEMBERSHIP && !calendar,
          [s.offerCalendar]: ribbon === RIBBON.MEMBERSHIP && calendar,
          [s.recurring]: ribbon === RIBBON.RECURRING && !calendar,
          [s.recurringCalendar]: ribbon === RIBBON.RECURRING && calendar,
        })}
        data-hook="ribbon"
      >
        <div>{t(text)}</div>
      </div>
    </div>
  )
}
